/* eslint-disable no-underscore-dangle */
import React from 'react';
import { SbEditableContent } from 'storyblok-react';
import { blokToComponent } from '../../../../helpers';
import { Props } from '../../../../types';

type PageProps = Props<{ body: SbEditableContent[] }>;

export const PageHeader = ({ blok, getComponent }: PageProps) => {
  const headline = {
    _uid: `${blok._uid}-header-headline`,
    component: 'roche-headline',
    force_level_style: blok.override_headline_level ? blok.headline_level : null,
    headline: blok.headline,
  };

  const subline = {
    _uid: `${blok._uid}-header-subline`,
    component: 'roche-richtext',
    text: blok.subline,
  };

  const introText = {
    _uid: `${blok._uid}-header-intro-text`,
    component: 'roche-richtext',
    text: blok.intro_text,
  };

  const downloadsJumplink = {
    _uid: `${blok._uid}-downloads-anchor-item`,
    component: 'roche-anchor-navigation-item',
    label: 'Zu den Downloads',
    target_id: 'downloads',
    icon: 'chevron-down',
    icon_size: 'huge',
  };

  const intro = [
    introText,
  ] as unknown[];

  if (blok.downloads?.length > 0) {
    intro.push({
      _uid: `${blok._uid}-header-grid-jumplink`,
      component: 'roche-grid-12',
      slotted: [downloadsJumplink],
    });
  }

  return <>
    {blokToComponent({
      blok: {
        _uid: `${blok._uid}-header-grid-1`,
        component: 'roche-grid-8',
        slotted: [headline, subline, ...intro],
      },
      getComponent,
    })}
  </>;
};
